import type { PreviewSource } from "./types";

/**
 * Builds the templated_preview URL. The preview source goes in the query string so that the same body
 * requested from two screens is recognized as a repeat on the server.
 *
 * The editor-domain iframe bridge forwards untyped args, so an older editor bundle can omit the source.
 * The param is left out then, so the server reports it as missing instead of unknown.
 */
export const templatedPreviewUrl = (appGroupId: string, previewSource: PreviewSource | undefined): string => {
  const url = `/engagement/${appGroupId}/templated_preview`;
  if (!previewSource) {
    return url;
  }
  return `${url}?${new URLSearchParams({ preview_source: previewSource }).toString()}`;
};
